module.exports = __webpack_public_path__ + "img/thumbnail_AmericanBison_m_normal.1d7f3cd9.png";